import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ExtensionList from './List';
import ExtensionCreate from './Create';
import ExtensionDetail from './Detail';

const defaultFields = {
    Compensation: { visible: false, label: '', required: false },
    Subject: { visible: false, label: '', required: false },
    ResponseRequiredDate: { visible: false, label: '', required: false },
    ProposedExtensionDate: { visible: false, label: '', required: false },
    InspectionDetails: { visible: false, label: '', required: false },
    QuoteReference: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    //wfid = 9
    let editingDateLabel = languageFile["CONTRACT.WF.EXTENSION.FIELD.CURRENT_RESPONSE_DATE"];
    let editingDetailLabel = resources.ExtensionPMLabel;

    if (wfid == 10) {
        editingDateLabel = languageFile["CONTRACT.WF.EXTENSION.FIELD.CURRENT_QUOTE_DATE"];
        editingDetailLabel = resources.ExtensionSupplierLabel;
    }

    fields.Compensation = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMPENSATION"], required: true };
    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.ResponseRequiredDate =  { visible: true, label: editingDateLabel, required: true };
    fields.ProposedExtensionDate = { visible: true, label: languageFile["CONTRACT.WF.EXTENSION.FIELD.PROPOSED_EXT_DATE"], required: true };
    fields.InspectionDetails =  { visible: true, label: editingDetailLabel, required: true };
    fields.QuoteReference =  { visible: true, label: languageFile["CONTRACT.WF.EXTENSION.FIELD.QUOTE_REFERENCE"], required: true };

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };

    var replyOptions = [
        { value: 'Accepted', display: languageFile["OPTIONS.STATUS.Accepted"] },
        { value: 'Not Accepted', display: languageFile["OPTIONS.STATUS.Not Accepted"] }
    ];

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: false };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: false };
    
    return replyFields;
}

class ExtensionRouter extends React.Component {
    constructor(props) {
        super(props);
        if (props.mode === 'SUPPLIER') {
            this.documentType = 'DocumentSupExt';
            this.notificationName = props.workflowItem.notificationName;
            this.abbreviation = props.workflowItem.abbreviation;
        }
        else if (props.mode === 'PM') {
            this.documentType = 'DocumentPmExt';
            this.notificationName = props.workflowItem.notificationName;
            this.abbreviation = props.workflowItem.abbreviation;
        }

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;

        this.replyPeriod = props.workflowItem.replyPeriod;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<ExtensionList
                        {...this.props}
                        mode={this.props.mode}
                        
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <ExtensionCreate
                                {...this.props}
                                replyPeriod={this.replyPeriod}
                                mode={this.props.mode}
                                instructionAbbreviation={this.instructionAbbreviation}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<ExtensionDetail
                        {...this.props}
                        replyPeriod={this.replyPeriod}
                        mode={this.props.mode}

                        earlyWarningTitle={this.earlyWarningTitle}
                        instructionAbbreviation={this.instructionAbbreviation}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};

export default (ExtensionRouter);